import api from './data.services'

const indentitiesSrv = 'indentities/verifications'
const solemNameSrv = '/patients/info'

const getIndentities = async () => {
  try {
    const resp: any = await api.get(`${indentitiesSrv}`)

    if(resp && resp.status === 200) {
      return {
        status: 'Ok',
        data: (resp.data ? resp.data : {})
      }
    }

    return {
      status: 'Error',
      message: (resp && resp.response && resp.response.data && resp.response.data.errors ? resp.response.data.errors : '')
    }
  } catch(error: any) {
    return {
      status: 'Error',
      message: (error && error.msg ? error.msg : 'Error server validar identidad')
    }
  }
}



const getSolemNamesByRut = async (rut: string) => {
  try {
    const resp: any = await api.getSrv(`${solemNameSrv}/${rut}`)
    return {
      status: 'Ok',
      data: (resp && resp.data && resp.data.data ? resp.data.data : {})
    }
  } catch (error) {
    return {
      status: 'Error',
      data: {},
      message: 'Error server al obtener nombres!'
    }
  }
}

export const solemService = {
  getIndentities,
  getSolemNamesByRut
}